import trTR from 'antd/locale/tr_TR';
import { appDayjs as dayjs } from '@saha/time';
import 'dayjs/locale/tr';

dayjs.locale('tr');

export { trTR as antdLocale };
